<template>
  <div v-loading="loading">
    <div class="header">
<!--      <el-radio-group v-model="period">-->
<!--        <el-radio-button label="day">День</el-radio-button>-->
<!--        <el-radio-button label="week">Неделя</el-radio-button>-->
<!--        <el-radio-button label="month">Месяц</el-radio-button>-->
<!--        <el-radio-button label="year">Год</el-radio-button>-->
<!--      </el-radio-group>-->
      <el-date-picker
          size="small"
          v-model="date"
          type="daterange"
          format="dd.MM.yyyy"
          placeholder="Выберите дату"
          unlink-panels
          range-separator="-"
          start-placeholder="С"
          end-placeholder="По"
          :picker-options="pickerOptions"
          class="date-picker"
      />
    </div>

<!--    <div class="indicators">-->
<!--      <div class="indicators__date">{{ title.date }}</div>-->
<!--      <div class="indicators__title">100 000 {{ title.date }}</div>-->
<!--      <div class="indicators__percent">шагов</div>-->
<!--    </div>-->

    <transition name="el-fade-in-linear">
      <chart :date="date" @mouseMove="mouseChart" :chart-data="chartData" class="chart"/>
    </transition>

  </div>
</template>
<script>
import Chart from "@/components/dynamics/ChartBar.vue"
import {mapGetters} from "vuex"

export default {
  name: "Devices",
  data() {
    return {
      loading: false,
      chartData: [],
      period: 'day',
      date: [new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 30 * 6)), new Date()],
      pickerOptions: {
        shortcuts: [{
          text: 'Неделя',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        },
          {
            text: 'Месяц ',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '3 месяца',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'год',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 12);
              picker.$emit('pick', [start, end]);
            }
          }]
      },
    }
  },
  components: {
    Chart
  },
  props: {
    device: {}
  },
  watch: {
    period() {
      this.loadLogic()
    },
    device() {
      this.loadLogic()
    },
  },
  date() {
    this.loadLogic()
  },
  computed: {
    ...mapGetters("visit", {
      visit: "data",
    }),
  },
  created() {
    this.loadLogic()
  },
  methods: {
    mouseChart () {

    },
    loadLogic() {
      this.loading = true

      let params = {
        userId: this.visit?.user?.id,
        deviceId: this.device,
        period: this.period,
      }

      this.$api.mobileDevice.getGraph({params}).then((response) => {
        this.chartData = response.data
      }).catch(() => {
        this.options = []
      }).finally(() => {
        this.loading = false
      })
    },

  }

}

</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0;

  margin-top: 16px;
}

.el-radio-button {
  margin: 0 5px 0 0;
}

.date-picker {
  width: 250px;
}

.indicators {
  margin-top: 18px;

  display: flex;
  align-items: center;
  justify-content: start;
  gap: 14px;

  font-weight: 600;
  font-size: 16px;
  line-height: 26px;

  &__date {
    color: #8E8E93;
  }

  &__title {
    color: #111111;
  }

  &__percent {
    color: #8E8E93;
  }
}

</style>